const React = require('react');
const map = require('mn-utils/map');
const upperFirst = require("mn-utils/upperFirst");
const withState = require('../../../../utils/withState');
const {
  apiAdminWalletList,
  apiAdminWalletActivateOne,
} = require('../../../../api/admin/wallet');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const SwitchA = require('../../../dumb/Switch/A');
const {WALLETS_DATA, WALLET_TYPES} = require('../../../../constants/wallets');


module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    setState({
      loading: true,
    });
    apiAdminWalletList().finally((error, response) => {

      const wallets = {};
      const walletsTypes = {};

      (response && response.list || []).forEach((el) => {
        const {id, name, is_enabled} = el;

        if (id === 'other') console.log(el);

        const tagsList = ((el.metadata || {}).tags || []);
        const type = tagsList.includes('app_pay')
          ? WALLET_TYPES.TYPE_APP_PAY
          : id === 'other'
            ? WALLET_TYPES.TYPE_MANUAL
            : id.includes('cxw_')
              ? WALLET_TYPES.TYPE_EXCHANGE
              // : id.includes('_web')
              //   ? TYPE_WALLET_WEB
              : WALLET_TYPES.TYPE_WALLET;

        if (!walletsTypes[type]) walletsTypes[type] = [];

        walletsTypes[type].push(id);
        wallets[id] = {
          name,
          enabled: is_enabled
        };
      });

      setState({
        walletsTypes,
        wallets,
        loading: false,
      });
    });
  });

  return (state) => {
    const wallets = state.wallets || {};
    const walletTypes = state.walletsTypes || {};
    const walletTypesIds = [
      WALLET_TYPES.TYPE_APP_PAY,
      WALLET_TYPES.TYPE_WALLET,
      WALLET_TYPES.TYPE_EXCHANGE,
      WALLET_TYPES.TYPE_MANUAL
    ];

    return (
      <WrapperWithLoading
        className="w"
        loading={state.loading}
      >
        {map(walletTypesIds, (type) => {
          const walletsIdsList = walletTypes[type] || [];

          if (!walletsIdsList.length) return;

          return (
            <div key={type} className="mt30">
              <div className="ttU cF">
                {type.split('_').map(upperFirst).join(' ')}
              </div>
              <div className="layoutRow fxwWrap mt5 mh-10 (w1/4@d3|w1/3@d|w1/2@m|w@m2|ph10|lt)>1">
                {map(walletsIdsList, (walletID) => {
                  const {name, enabled} = (wallets[walletID] || {});
                  return (
                    <SwitchA
                      key={name}
                      label={<div
                        className="lh break"
                      >{name}</div>}
                      checked={enabled}
                      onChange={() => {
                        setState({
                          loading: true,
                        });
                        apiAdminWalletActivateOne({
                          wallet: walletID,
                          enable: !enabled,
                        }).finally((error, response) => {

                          const nextWalletsData = {...wallets};

                          if (!error) {
                            nextWalletsData[walletID] = {...nextWalletsData[walletID], enabled: !enabled}
                          }


                          setState({
                            loading: false,
                            wallets: nextWalletsData,
                          });
                        });
                      }}
                    />
                  )})}
              </div>
            </div>
          )
        })}

        {/*<div className="layoutRow fxwWrap mh-10 (w1/4@d3|w1/3@d|w1/2@m|w@m2|ph10|lt)>1">*/}
        {/*  {map(wallets, (wallet) => {*/}
        {/*    const {*/}
        {/*      name,*/}
        {/*      enabled,*/}
        {/*    } = wallet;*/}

        {/*    const data = WALLETS_DATA[name] || {};*/}

        {/*    return (*/}
        {/*      <SwitchA*/}
        {/*        key={name}*/}
        {/*        label={<div*/}
        {/*          className="lh break"*/}
        {/*        >{data.name || name}</div>}*/}
        {/*        checked={enabled}*/}
        {/*        onChange={() => {*/}
        {/*          setState({*/}
        {/*            loading: true,*/}
        {/*          });*/}
        {/*          apiAdminWalletActivateOne({*/}
        {/*            wallet: name,*/}
        {/*            enable: !enabled,*/}
        {/*          }).finally((error, response) => {*/}
        {/*            setState({*/}
        {/*              loading: false,*/}
        {/*              wallets: error ? wallets : map(wallets, (item) => {*/}
        {/*                return item.name === name ? {*/}
        {/*                  ...item,*/}
        {/*                  enabled: !enabled,*/}
        {/*                } : item;*/}
        {/*              }),*/}
        {/*            });*/}
        {/*          });*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    );*/}
        {/*  }, [])}*/}
        {/*</div>*/}
      </WrapperWithLoading>
    );
  };
}, {});
